<template>
  <div class="app_warp">
    <div class="title_warp"><h1>{{dataobjs.appguanli}}</h1></div>
    <div class="bten">
      <el-button type="primary" @click="handUpperdata">{{dataobjs.xinzeng}}</el-button>
    </div>
    <div class="forData">
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
      >
        <el-table-column prop="version_number" :label="dataobjs.banbenhao">
          <template slot-scope="{ row }">
            <el-tag>{{ row.version_number }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="version_content" :label="dataobjs.banbenjieshao">
        </el-table-column>
        <el-table-column prop="version_url" :label="dataobjs.xiazaidizhi"> </el-table-column>
        <el-table-column prop="version_number" :label="dataobjs.caozuo" width="200">
          <template slot-scope="{ row }">
            <!--   @click="editFrom(row)" -->
            <el-button
              size="mini"
              round
              icon="el-icon-edit"
              type="primary"
              @click="editFrom(row)"
              >{{dataobjs.xiugai}}</el-button
            >
            <!--    -->
            <el-button
              size="mini"
              type="danger"
              @click="deleData(row)"
              icon="el-icon-delete"
              round
              >{{dataobjs.shanchu}}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <page-helper
        :page-data="pageData"
        :total="total"
        :get-table-list="appDataUpdata"
      ></page-helper>
    </div>
    <!-- 新增弹出框 -->
    <el-dialog
      :title="title"
      :visible.sync="centerDialogVisible"
      width="34%"
      :modal="false"
      :close-on-click-modal="false"
      center
      :before-close="handleClose"
    >
      <Add
        :fromdata="formLabelAlign"
        ref="AddWhat"
        :file-list="fileList"
        :dataobjs="dataobjs"
        :handhide="handhHide"
        :appDataupdata="appDataUpdata"
      />
    </el-dialog>
  </div>
</template>

<script>
// tb_version
import { appDataUpdata, dealerDelete,lang_fend } from "../../network/index";
import Add from "./components/add";
import PageHelper from "@/components/common/PageHelper";

export default {
  components: {
    Add,
    PageHelper,
  },
  data() {
    return {
      centerDialogVisible: false,
      formLabelAlign: {
        version_number: "",
        version_content: "",
        version_url: "",
      },
      fileList: [],
      tableData: [],
      pageData: {
        pagenum: 1, //页码  pagenum  2
        pagesize: 30, //数据   pagesize几条数据
      },
      total: null,
      title: "",
        lang_file: sessionStorage.getItem("lang_file"),
        dataobjs:{}
    };
  },
  created() {},
  mounted() {
    this.appDataUpdata();
    this.lang_fend()
  },
  methods: {
    // 翻译
    async lang_fend() {
      let page = "appset_page";
      let objs = {
        page,
        lang_file: this.lang_file,
      };
      const { data, code } = await lang_fend(objs);
          
      this.dataobjs = data;
    },
    //   列表
    async appDataUpdata() {
      const { code, data } = await appDataUpdata(this.pageData);
      this.tableData = data.list;
      this.total = Number(data.pagelist[0].allrow);
    },
    // 修改
    editFrom(row) {
      // console.log(row);
      this.title = this.dataobjs.xiugai;
      (this.formLabelAlign = {
        uuid: row.uuid,
        version_number: row.version_number,
        version_content: row.version_content,
        version_url: row.version_url,
      }),
        (this.fileList = []);
      this.fileList.push({
        url: row.version_url,
        name: row.addtime,
      });
      this.centerDialogVisible = true;
    },
    // 删除
    deleData(e) {
      let tablename = "tb_version";
     this.$confirm(`${this.dataobjs.tishixinxi}`, `${this.dataobjs.tishi}`, {
        confirmButtonText: `${this.dataobjs.queding}`,
        cancelButtonText: `${this.dataobjs.quxiao}`,
        closeOnClickModal: false,
        type: "warning",
      })
        .then(async () => {
          const { code, msg } = await dealerDelete(e.uuid, tablename);
          if (code) {
            this.appDataUpdata();
            this.$message({
              type: "success",
            message:`${this.dataobjs.shanchuchenggong}`,
            });
          } else {
            this.$message.error(msg);
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
           message:`${this.dataobjs.yiquxiaoshanchu}`,
          });
        });
    },
    handleClose() {
      (this.formLabelAlign = {
        uuid: "",
        version_number: "",
        version_content: "",
        version_url: "",
      }),
        (this.centerDialogVisible = false);
    },
    // 隐藏的公共方法
    handhHide() {
      this.centerDialogVisible = false;
    },
    // 新增版本信息
    handUpperdata() {
      this.fileList = [];
      (this.formLabelAlign = {
        uuid: "",
        version_number: "",
        version_content: "",
        version_url: "",
      }),
        (this.title = this.dataobjs.xinzeng);
      this.centerDialogVisible = true;
    },
  },
};
</script>

<style scoped>
.app_warp {
  height: 100%;
  /* background: #eeeeee; */
}
.title_warp {
  text-align: center;
  font-size: 32px;
  height: 60px;
}

.forData {
  /* width: 850px; */
  /* margin: 0 auto; */
  /* background: #ffffff; */
}
.bten {
  padding-bottom: 20px;
  margin-left: 20px;
}
.bents {
  text-align: center;
  padding: 30px 0;
}
</style>
